import React from "react";

import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import SimpleImageTextSide from "../../../../../../patterns/wpl/simple-image-text-side/src";

const ThreeAlternatingImageTextStyles = css({
    ".background-side-by-side": {
        backgroundImage: "linear-gradient(225deg, #DEEBFF 0%, #FFFFFF 100%)"
    },
    ".row-layout": {
        "padding": "16px",
        "width": "100%",
        "marginInlineStart": "auto",
        "marginInlineEnd": "auto",
        "@media (min-width: 768px)": {
            width: "100%",
            margin: "0px",
            maxWidth: "1200px",
            marginInlineStart: "auto",
            marginInlineEnd: "auto"
        }
    },
    "img": {
        "display": "block",
        "marginInlineStart": "auto",
        "marginInlineEnd": "auto",
        "@media (max-width: 767.98px)": {
            order: 0
        },
        "@media (min-width: 768px)": {
            width: "550px"
        }
    },
    ".text-section": {
        "@media (min-width: 768px)": {
            maxWidth: "568px"
        },
        "h2": {
            "color": "#253858",
            "fontSize": "1.5rem",
            "margin": "0 0 14px",
            "lineHeight": "1.33",
            "@media (min-width: 768px)": {
                fontSize: "2.25rem",
                margin: "0 0 24px "
            }
        },
        "hr": {
            margin: "0 0 40px",
            border: 0,
            backgroundColor: "#b2d4ff"
        },
        "p": {
            "color": "#091e42",
            "margin-bottom": 0
        }
    },
    ".image-text-side-row-1": {
        "padding": "64px 0 16px",
        "@media (min-width: 768px)": {
            padding: "64px 0 16px"
        }
    },
    ".image-text-side-row-2": {
        "padding": "32px 0",
        "@media (min-width: 768px)": {
            padding: "16px 0"
        }
    },
    ".image-text-side-row-3": {
        "padding": "16px 0 64px",
        "@media (min-width: 768px)": {
            padding: "16px 0 64px"
        }
    }
});

const SideBySideAlternatingImageAndTextSectionPaidLpJswPm = () => {
    const intl = useIntl();
    const firstImageTextSideSectionObject = {
        imageSrc:
            "https://wac-cdn.atlassian.com/dam/jcr:984ab7c2-c053-4906-b022-aa3ff74e13d5/TRACK%20PROGRESS@2x.png?cdnVersion=ece",
        headerText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.firstImageTextSideSectionObject.headerText",
            defaultMessage: "Bring the big picture into view"
        }),
        bodyText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.firstImageTextSideSectionObject.bodyText",
            defaultMessage:
                "Easily track your team’s progress, priorities, and workload. Identify blockers, celebrate wins, and plan ahead so your team never misses a beat and projects always stay on track."
        }),
        imageAltText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.firstImageTextSideSectionObject.imageAltText",
            defaultMessage: "Track progress"
        })
    };
    const secondImageTextSideSectionObject = {
        imageSrc:
            "https://wac-cdn.atlassian.com/dam/jcr:960af1e7-aa6c-402e-a710-64b45d227a99/templates-screenshot.png?cdnVersion=ece",
        headerText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.secondImageTextSideSectionObject.headerText",
            defaultMessage: "Get going with templates"
        }),
        bodyText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.secondImageTextSideSectionObject.bodyText",
            defaultMessage:
                "Choose from over 40 pre-made templates for marketing, HR, finance, and more. From project management to budget process, there's a template to help any project up and running."
        }),
        imageAltText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.secondImageTextSideSectionObject.imageAltText",
            defaultMessage: "Templates"
        })
    };
    const thirdImageTextSideSectionObject = {
        imageSrc:
            "https://wac-cdn.atlassian.com/dam/jcr:d243232a-180a-4c73-8352-ade940df54ef/FUN@2x.png?cdnVersion=ece",
        headerText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.thirdImageTextSideSectionObject.headerText",
            defaultMessage: "Make work fun"
        }),
        bodyText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.thirdImageTextSideSectionObject.bodyText",
            defaultMessage:
                "Every team is unique. Work the way you want with customizable backgrounds that showcase your personality."
        }),
        imageAltText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.thirdImageTextSideSectionObject.imageAltText",
            defaultMessage: "Fun"
        })
    };
    const forthImageTextSideSectionObject = {
        imageSrc:
            "https://wac-cdn.atlassian.com/dam/jcr:11e3f8cf-9c2d-4739-a4c8-8d361908b6c0/TOOLS@2x.png?cdnVersion=ece",
        headerText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.forthImageTextSideSectionObject.headerText",
            defaultMessage: "Teamwork is easier when tools talk"
        }),
        bodyText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.forthImageTextSideSectionObject.bodyText",
            defaultMessage:
                "Craft your team’s perfect process with over 3000 extensions and 500 integrations."
        }),
        imageAltText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.forthImageTextSideSectionObject.imageAltText",
            defaultMessage: "Tools"
        })
    };

    return (
        <section css={ThreeAlternatingImageTextStyles}>
            <div className="background-side-by-side">
                <SimpleImageTextSide
                    headerText={firstImageTextSideSectionObject.headerText}
                    bodyText={firstImageTextSideSectionObject.bodyText}
                    imageLink={firstImageTextSideSectionObject.imageSrc}
                    imageAltText={firstImageTextSideSectionObject.imageAltText}
                    horizontalRule={true}
                    className="image-text-side-row-1"
                />
                <SimpleImageTextSide
                    headerText={secondImageTextSideSectionObject.headerText}
                    bodyText={secondImageTextSideSectionObject.bodyText}
                    imageLink={secondImageTextSideSectionObject.imageSrc}
                    imageAltText={secondImageTextSideSectionObject.imageAltText}
                    imagePosition="left"
                    horizontalRule={true}
                    className="image-text-side-row-2"
                />
                <SimpleImageTextSide
                    headerText={thirdImageTextSideSectionObject.headerText}
                    bodyText={thirdImageTextSideSectionObject.bodyText}
                    imageLink={thirdImageTextSideSectionObject.imageSrc}
                    imageAltText={thirdImageTextSideSectionObject.imageAltText}
                    horizontalRule={true}
                    className="image-text-side-row-2"
                />
                <SimpleImageTextSide
                    headerText={forthImageTextSideSectionObject.headerText}
                    bodyText={forthImageTextSideSectionObject.bodyText}
                    imageLink={forthImageTextSideSectionObject.imageSrc}
                    imageAltText={forthImageTextSideSectionObject.imageAltText}
                    imagePosition="left"
                    horizontalRule={true}
                    className="image-text-side-row-3"
                />
            </div>
        </section>
    );
};

export default SideBySideAlternatingImageAndTextSectionPaidLpJswPm;
